import React from 'react';
import { View } from 'react-native';

import { AppEnv } from '@components/AppEnv';
import { Button } from '@components/Button';
import { Icon } from '@components/Icon';
import { makeStyles } from '@providers/Theme';
import { useDrawerStateStore } from '@stores/drawer';
import { useNavigation } from '@hooks';

import { AnimatedLogo } from './AnimatedLogo';

type MobileAppBarProps = {};

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: 64,
    flexDirection: 'row',
    borderStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: theme.palette.grey[400],
    zIndex: 1,
    ...theme.mixins.padding(1),
  },
  homeButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  menuButton: {},
  appEnv: {},
}));

export const MobileAppBar: React.FC<MobileAppBarProps> = () => {
  const navigation = useNavigation();
  const styles = useStyles();
  const { isOpen } = useDrawerStateStore();

  return (
    <View style={styles.root}>
      <View style={styles.homeButton}>
        <Button
          onPress={() => {}}
          startIcon={<AnimatedLogo expanded={isOpen} />}
          // touchSoundDisabled
          // activeOpacity={1}
        />

        <AppEnv />
      </View>

      <Button
        onPress={() => {
          if (isOpen) {
            navigation.closeDrawer();
          } else {
            navigation.openDrawer();
          }
        }}
        style={styles.menuButton}
        startIcon={
          <Icon
            name={isOpen ? 'close' : 'burger'}
            size={24}
            color={(theme) => theme.palette.cool[700]}
          />
        }
      />
    </View>
  );
};
